import React from 'react';

import { Container } from './styles';

export default function Header() {
  return (
      <Container>
          <h1>Rocketfy</h1>
      </Container>
  );
}
